export default __webpack_public_path__ + "static/media/maison.d609307a.png";